module.exports = __webpack_public_path__ + "img/buy.03338f5d.svg";